export const NEW_BO_APP_REDIRECT_MAP: Record<string, string> = {
    '/login': '/sign-in',
    '/otp': '/otp',
    '/': '/',
    '/bets-history': '/reports/bet-history',
    '/gaming-activity': '/reports/gaming-activity',
    '/accounts/users': '/accounts/users',
};

export const generateNewBackOfficeUrl = (pagePath: string) => {
    return (
        process.env.REACT_APP_HTTP_PREFIX +
        process.env.REACT_APP_NEW_ONLINE_BO_APP_PREFIX +
        process.env.REACT_APP_BASE_DOMAIN +
        pagePath
    );
};
